import abi from '../public/pmv_abi.json';
export const contract = {
  name: "Pirate NFTs",
  address: process.env.NEXT_PUBLIC_ETH_SMARTCONTRACT_ADDRESS,
  abi,
  testFunction: "owner"
};